import React from "react";
import HitlQueue from "./HitlQueue";
import { useLaunchParams } from "./shared/useLaunchParams";
import { chassis } from "./shared/chassis";
import { useT } from "../../../stores/uiLang";
import { REVIEW_T } from "../../../i18n/teacherDashboard";

/**
 * LTI route wrapper for the teacher HITL queue. Chapter context is optional —
 * without it the queue shows all pending items across all chapters.
 */
const HitlQueuePage: React.FC = () => {
  const { chapterId, role, ltik } = useLaunchParams();
  const t = useT(REVIEW_T);

  if (role !== "teacher") {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: chassis.background }}>
        <div className="text-center max-w-md px-6">
          <h1 className="text-xl font-bold mb-2" style={{ color: chassis.textPrimary }}>
            {t.teachersOnlyTitle}
          </h1>
          <p style={{ color: chassis.textSecondary }}>
            {t.teachersOnly}
          </p>
        </div>
      </div>
    );
  }

  return <HitlQueue chapterId={chapterId} ltik={ltik} />;
};

export default HitlQueuePage;
